// // import { useEffect, useState } from "react";
// // import { Card, message, Spin, Flex, Tag, Tooltip } from "antd";
// // import { useNavigate } from "react-router-dom";
// // import { fetchMachine } from "../../../../configuration/module/MachineConfiguration/Service/machine";

// // const AssetWiseList = () => {
// //   const [machines, setMachines] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const navigate = useNavigate();

// //   // Fetch machines (assets)
// //   const fetchData = async () => {
// //     setLoading(true);
// //     try {
// //       const res = await fetchMachine();
// //       if (res?.data) {
// //         // Add dummy runtime, downtime, and status for UI
// //         const withStatus = res.data.map((m) => ({
// //           ...m,
// //           isConnected: Math.random() > 0.3, // simulate connection
// //           status: ["Running", "Idle", "Disconnected"][
// //             Math.floor(Math.random() * 3)
// //           ],
// //           runtime: Math.floor(Math.random() * 8) + "h",
// //           downtime: Math.floor(Math.random() * 3) + "h",
// //           hasWarning: Math.random() > 0.7,
// //         }));
// //         setMachines(withStatus);
// //       } else {
// //         message.error("Invalid response from server");
// //       }
// //     } catch (err) {
// //       message.error("Error fetching machine list");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const toggleConnection = (uuid) => {
// //     setMachines((prev) =>
// //       prev.map((m) =>
// //         m.uuid === uuid ? { ...m, isConnected: !m.isConnected } : m
// //       )
// //     );
// //     message.success("Connection state updated");
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, []);

// //   const getStatusColor = (status) => {
// //     switch (status) {
// //       case "Running":
// //         return "green";
// //       case "Idle":
// //         return "gold";
// //       default:
// //         return "volcano";
// //     }
// //   };

// //   return (
// //     <div style={{ width: "100%" }}>
// //       <Flex justify="left" align="center" style={{ marginBottom: 16 }}>
// //         <div style={{ fontSize: "1rem", fontWeight: 700 }}>Live Monitoring</div>
// //       </Flex>

// //       <Spin spinning={loading}>
// //         <div
// //           style={{
// //             display: "grid",
// //             gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
// //             gap: 20,
// //           }}
// //         >
// //           {machines.map((machine) => (
// //             <Card
// //               key={machine.uuid}
// //               hoverable
// //               style={{
// //                 borderRadius: 12,
// //                 boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
// //                 overflow: "hidden",
// //               }}
// //               onClick={() => navigate(`/ams/live-monitoring/${machine.uuid}`)}
// //               cover={
// //                 <img
// //                   alt="machine"
// //                   src={`${process.env.PUBLIC_URL}/images/general-machine.png`}
// //                   style={{
// //                     width: "100%",
// //                     height: 160,
// //                     objectFit: "cover",
// //                   }}
// //                 />
// //               }
// //             >
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   justifyContent: "space-between",
// //                   alignItems: "center",
// //                 }}
// //               >
// //                 <div style={{ fontWeight: 600, fontSize: "1rem" }}>
// //                   {machine.assetName}
// //                 </div>
// //               </div>

// //               <div
// //                 style={{
// //                   marginTop: 8,
// //                   display: "flex",
// //                   justifyContent: "flex-end",
// //                 }}
// //               >
// //                 <Tag
// //                   color={getStatusColor(machine.status)}
// //                   style={{ fontWeight: 600 }}
// //                 >
// //                   {machine.connectionStatus ? "Connected" : "Disconnected"}
// //                 </Tag>
// //               </div>
// //             </Card>
// //           ))}
// //         </div>
// //       </Spin>
// //     </div>
// //   );
// // };

// // export default AssetWiseList;

// import { useEffect, useState } from "react";
// import { Button, Card, message, Spin, Flex, Tag, Tooltip, Space } from "antd";
// import { useNavigate } from "react-router-dom";
// import { fetchMachine } from "../../../../configuration/module/MachineConfiguration/Service/machine";
// import { ThunderboltOutlined, EyeOutlined } from "@ant-design/icons";

// const AssetWiseList = () => {
//   const [machines, setMachines] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const res = await fetchMachine();
//       if (res?.data) {
//         const withStatus = res.data.map((m) => ({
//           ...m,
//           isConnected: Math.random() > 0.3,
//           status: ["Running", "Idle", "Disconnected"][Math.floor(Math.random() * 3)],
//           runtime: Math.floor(Math.random() * 8) + "h",
//           downtime: Math.floor(Math.random() * 3) + "h",
//           hasWarning: Math.random() > 0.7,
//         }));
//         setMachines(withStatus);
//       } else {
//         message.error("Invalid response from server");
//       }
//     } catch (err) {
//       message.error("Error fetching machine list");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Running":     return "green";
//       case "Idle":        return "gold";
//       default:            return "volcano";
//     }
//   };

//   return (
//     <div style={{ width: "100%" }}>
//       <Flex justify="left" align="center" style={{ marginBottom: 16 }}>
//         <div style={{ fontSize: "1rem", fontWeight: 700 }}>Live Monitoring</div>
//       </Flex>

//       <Spin spinning={loading}>
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
//             gap: 20,
//           }}
//         >
//           {machines.map((machine) => (
//             <Card
//               key={machine.uuid}
//               style={{
//                 borderRadius: 12,
//                 boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                 overflow: "hidden",
//               }}
//               cover={
//                 <img
//                   alt="machine"
//                   src={`${process.env.PUBLIC_URL}/images/general-machine.png`}
//                   style={{ width: "100%", height: 160, objectFit: "cover", cursor: "pointer" }}
//                   onClick={() => navigate(`/ams/live-monitoring/${machine.uuid}`)}
//                 />
//               }
//             >
//               {/* Asset name */}
//               <div style={{ fontWeight: 600, fontSize: "1rem", marginBottom: 8 }}>
//                 {machine.assetName}
//               </div>

//               {/* Status tag */}
//               <div style={{ marginBottom: 12 }}>
//                 <Tag color={getStatusColor(machine.status)} style={{ fontWeight: 600 }}>
//                   {machine.connectionStatus ? "Connected" : "Disconnected"}
//                 </Tag>
//               </div>

//               {/* Action buttons */}
//               <Space style={{ width: "100%" }}>
//                 <Tooltip title="Live Monitoring — view real-time data">
//                   <Button
//                     icon={<EyeOutlined />}
//                     size="small"
//                     style={{ flex: 1 }}
//                     onClick={() => navigate(`/ams/live-monitoring/${machine.uuid}`)}
//                   >
//                     Monitor
//                   </Button>
//                 </Tooltip>

//                 <Tooltip title="Write Control — send commands to this asset">
//                   <Button
//                     icon={<ThunderboltOutlined />}
//                     size="small"
//                     type="primary"
//                     style={{
//                       flex: 1,
//                       background: "#fa8c16",
//                       borderColor: "#fa8c16",
//                     }}
//                     onClick={() => navigate(`/ams/write-control/${machine.uuid}`)}
//                   >
//                     Write Control
//                   </Button>
//                 </Tooltip>
//               </Space>
//             </Card>
//           ))}
//         </div>
//       </Spin>
//     </div>
//   );
// };

// export default AssetWiseList;

import { useEffect, useState } from "react";
import { Card, message, Spin, Flex, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { fetchMachine } from "../../../../configuration/module/MachineConfiguration/Service/machine";

const AssetWiseList = () => {
  const [machines, setMachines] = useState([]);
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetchMachine();
      if (res?.data) {
        setMachines(res.data);
      } else {
        message.error("Invalid response from server");
      }
    } catch (err) {
      message.error("Error fetching machine list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const getStatusColor = (status) => {
    if (status === "Running") return "green";
    if (status === "Idle")    return "gold";
    return "volcano";
  };

  return (
    <div style={{ width: "100%" }}>
      <Flex justify="left" align="center" style={{ marginBottom: 16 }}>
        <div style={{ fontSize: "1rem", fontWeight: 700 }}>Live Monitoring</div>
      </Flex>

      <Spin spinning={loading}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: 20,
          }}
        >
          {machines.map((machine) => (
            <Card
              key={machine.uuid}
              hoverable
              style={{ borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.1)", overflow: "hidden", cursor: "pointer" }}
              onClick={() => navigate(`/ams/live-monitoring/${machine.uuid}`)}
              cover={
                <img
                  alt="machine"
                  src={`${process.env.PUBLIC_URL}/images/general-machine.png`}
                  style={{ width: "100%", height: 160, objectFit: "cover" }}
                />
              }
            >
              <div style={{ fontWeight: 600, fontSize: "1rem", marginBottom: 8 }}>
                {machine.assetName}
              </div>
              <Tag color={getStatusColor(machine.status)} style={{ fontWeight: 600 }}>
                {machine.connectionStatus ? "Connected" : "Disconnected"}
              </Tag>
            </Card>
          ))}
        </div>
      </Spin>
    </div>
  );
};

export default AssetWiseList;